module.exports = __webpack_public_path__ + "img/warning.75f515a9.svg";